var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvancedSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 30 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "advanced_search",
    d: "M4,16.808V13.923h7.5v2.885ZM4,26.9V24.019h7.5V26.9ZM32.425,37l-6-7.692a6.8,6.8,0,0,1-2.1,1.442A5.86,5.86,0,0,1,22,31.231a6.54,6.54,0,0,1-5.306-2.812,10.726,10.726,0,0,1-2.194-6.8,10.726,10.726,0,0,1,2.194-6.8,6.412,6.412,0,0,1,10.612,0,10.726,10.726,0,0,1,2.194,6.8,11.8,11.8,0,0,1-.375,2.981A10.184,10.184,0,0,1,28,27.288l6,7.692ZM22,28.346a4.578,4.578,0,0,0,3.712-1.971,7.5,7.5,0,0,0,1.538-4.76,7.5,7.5,0,0,0-1.538-4.76,4.482,4.482,0,0,0-7.425,0,7.5,7.5,0,0,0-1.538,4.76,7.5,7.5,0,0,0,1.538,4.76A4.578,4.578,0,0,0,22,28.346ZM4,37V34.115H19V37Z",
    transform: "translate(-4 -12)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearch);
export default __webpack_public_path__ + "static/media/advanced_search.4a02f54f6744646ba88971b7513cec4d.svg";
export { ForwardRef as ReactComponent };